import Vue from 'vue';
import pixNavbarMenuItem from '@/components/home/pixNavbar/pixNavbarMenuItem.vue';

const registerGlobalComponents = () => {
  Vue.component('pix-navbar-menu-item', pixNavbarMenuItem);
};

export default {
  registerGlobalComponents,
};
